function ErrorPage() {
  return (
    <center>
      <h1 className='text-red-500 font-bold' style={{ fontSize: '34px' }}>
        Page Not Found
      </h1>
    </center>
  );
}

export default ErrorPage;
